import { PAGE_HOME_URL, PAGE_INCLUSIONE_CORSO_ITALIANO, PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO, PAGE_HOME_INCLUSIONE } from 'types/url';

export const BreadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Apprendimento della lingua italiana',
    url: PAGE_INCLUSIONE_APPRENDIMENTO_ITALIANO,
  },
  {
    slash: 'CERCO UN CORSO DI ITALIANO A MILANO',
    url: PAGE_INCLUSIONE_CORSO_ITALIANO,
  },
];
